<template>
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-card-title class="headline">Kirjaudu sisään</v-card-title>
              <v-card-text>
                <v-form @submit.prevent="handleLogin">
                  <v-text-field
                    v-model="username"
                    label="Käyttäjänimi"
                    outlined
                    required
                    :disabled="loading"
                    autofocus
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    label="Salasana"
                    type="password"
                    outlined
                    required
                    :disabled="loading"
                    @keyup.enter="handleLogin"
                  ></v-text-field>
                  <v-alert v-if="error" type="error" dense class="mb-3">
                    {{ error }}
                  </v-alert>
                  <v-btn
                    type="submit"
                    color="primary"
                    block
                    :loading="loading"
                    :disabled="loading"
                  >
                    Kirjaudu
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: ''
  }),
  computed: {
    ...mapGetters('auth', ['authError', 'isLoading']),
    error() {
      return this.authError;
    },
    loading() {
      return this.isLoading;
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async handleLogin() {
      try {
        await this.login({
          username: this.username,
          password: this.password
        });
        this.$router.push('/');
      } catch (error) {
        // Error already in store
      }
    }
  }
};
</script>
